<template>
  <div class="loader-container">
    <div class="progress-container">
      <div class="progress-bar"></div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, defineProps, defineEmits } from "vue";

const props = defineProps({
  query: {
    type: String,
    default: ''
  }
});

const emit = defineEmits(['navigate']);

onMounted(() => {
  setTimeout(() => {
    emit('navigate', {
      component: 'IndexView',
      query: props.query
    });
  }, 3000);
});
</script>

<style scoped>
.loader-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f8f9fa;
}

.progress-container {
  width: 200px;
  height: 4px;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  overflow: hidden;
}

.progress-bar {
  width: 100%;
  height: 100%;
  background-color: #026FC2;
  animation: progress 3s linear;
  transform-origin: left;
}

@keyframes progress {
  0% {
    transform: scaleX(0);
  }
  100% {
    transform: scaleX(1);
  }
}
</style>